import { AxiosResponse } from 'axios';
import api from '../api';
import { LAYOUT_TYPE } from '../constants/common.constant';
import { SORT_ORDER } from '../constants/filter.constant';
import {
  DefaultResponse,
  InstitutionProp,
  UserResponse,
} from '../interfaces/index';

const LAYOUT_URL = '/ris/layouts/v1';

export interface ParamsGetLayouts {
  active?: boolean;
  institution_ids?: string[] | string;
  limit?: number;
  name?: string;
  offset?: number;
  sort_field?:
    | ''
    | 'name'
    | 'user_id'
    | 'created_at'
    | 'updated_at'
    | 'insitiution_id';
  sort_order?: SORT_ORDER;
  status?: LAYOUT_TYPE;
  updated_at_from?: string;
  updated_at_to?: string;
  user_ids?: string[];
}
export interface ResponseGetLayouts extends DefaultResponse {
  data: {
    active: boolean;
    content: string;
    created_at: string;
    id: string;
    institution: InstitutionProp;
    institution_id: string;
    name: string;
    status: number;
    updated_at: string;
    user: UserResponse;
    user_id: string;
  }[];
}
export const getLayouts = async (params: ParamsGetLayouts = {}) => {
  const response = (await api({
    url: LAYOUT_URL,
    method: 'GET',
    params,
    timeout: 30_000,
  })) as AxiosResponse<ResponseGetLayouts>;

  return response.data;
};

export interface ParamsCreateLayout {
  active: boolean;
  content: string;
  institution_id: string;
  name: string;
  status: number;
}
export const createLayout = async (data: ParamsCreateLayout) => {
  const response = (await api({
    url: LAYOUT_URL,
    method: 'POST',
    data,
  })) as AxiosResponse<any>;

  return response.data;
};

export interface ParamsUpdateLayout {
  active: boolean;
  content: string;
  name: string;
  status: number;
}
export const updateLayout = async (id: string, data: ParamsUpdateLayout) => {
  const response = (await api({
    url: `${LAYOUT_URL}/${id}`,
    method: 'PUT',
    data,
  })) as AxiosResponse<any>;

  return response.data;
};

export const deleteLayout = async (id: string) => {
  const response = (await api({
    url: `${LAYOUT_URL}/${id}`,
    method: 'DELETE',
  })) as AxiosResponse<any>;

  return response;
};
